export default "__VITE_ASSET__BDY2SYM2__"